import { render, staticRenderFns } from "./NoClients.vue?vue&type=template&id=44b99820&scoped=true&"
import script from "./NoClients.vue?vue&type=script&lang=js&"
export * from "./NoClients.vue?vue&type=script&lang=js&"
import style0 from "./NoClients.vue?vue&type=style&index=0&id=44b99820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b99820",
  null
  
)

export default component.exports